import { ref, defineComponent, reactive, PropType, watch, computed, onMounted } from 'vue';
import {
  ElSlider,
  dayjs,
  ElTooltip,
  ElRadioGroup,
  ElRadio,
} from 'element-plus';
import { useStore } from '@/store';
import Mark from '@/components/Mark/index.vue';
import styles from './index.module.less';
import { PlayStateEnum } from '@/store/modules/ws/types';
import playIcon from '@/assets/images/play.png';
import pauseIcon from '@/assets/images/pause.png';
import nextIcon from '@/assets/images/next.png';
import prevIcon from '@/assets/images/prev.png';
import { PerspectiveEnum } from '@/store/types';
import { useFrameDataStore } from "@/store/frameDataStore";
import { scanOverwriteInstructionTransitions } from '@/utils/dataCache';
import { alignServerTimeToClient, offsetSampleVersion } from '@/utils/timeAlign';
const props = {
  getPlayInfo: {
    type: Function as PropType<(vehicleId: string, startTime: number, endTime: number) => void>,
    default: () => { },
  },
  tags: {
    type: Array as PropType<
      Array<{
        ts: number;
        tag: string;
      }>
    >,
    default: [],
  },
  varguardError: {
    type: Array as PropType<
      Array<{
        ts: number;
        tag: string;
      }>
    >,
    default: [],
  },
  varguardFatal: {
    type: Array as PropType<
      Array<{
        ts: number;
        tag: string;
      }>
    >,
    default: [],
  },
  varguardFristFatal: {
    type: Array as PropType<
      Array<{
        ts: number;
        tag: string;
      }>
    >,
    default: [],
  },
  alarmCodeList: {
    type: Array as PropType<
      Array<{
        ts: number;
        tag: string;
      }>
    >,
    default: [],
  },
  // 车辆操作日志（一键挪车等），结构与上面一致，但时间字段是 operateTime
  operationLog: {
    type: Array as PropType<Array<any>>,
    default: [],
  },
};

const NewProgress = defineComponent({
  name: 'NewProgress',
  props,
  setup(props) {
    const frameDataStore = useFrameDataStore()
    const { getPlayInfo } = props;
    const store = useStore();
    const min = ref<number>(0);
    const max = ref<number>(0);
    const progressValue = ref<number>();
    const progress_status = ref<number>(0);
    const marks = reactive<{ value: { [key: number]: any } }>({ value: {} });
    let marksTimeLink = 0;//标识queryTS 标记了跳转时间的，做一个mark
    const value = ref();
    const progressRef = ref();
    const left = -9999;
    const tip = ref({
      left,
      content: '',
    });

    onMounted(() => {
      //      
      window.addEventListener('keydown', onKeyUp);
    })
    function onKeyUp(e: KeyboardEvent) {
      if (e.keyCode === 50 || e.keyCode == 39) {
        //2 后一帧数据
        frameDataStore.playFrameOne(1)
      } else if (e.keyCode === 49 || e.keyCode == 37) {
        //1 前一帧数据
        frameDataStore.playFrameOne(-1)
      } else if (e.code == 'Space') {
        //空格
        if (frameDataStore.progress_status > 0) {
          frameDataStore.setProgress_status(0)
        } else {
          frameDataStore.setProgress_status(1)
        }
      }
    }

    /**
     * 播放进度调整事件
     */
    const sendProgress = (val: number) => {
    };
    /**
     * 播放当前值
     */
    watch(() => frameDataStore.currentTime, (value) => {
      progressValue.value = value

    })
    /**
     * 播放当前值
     */
    watch(() => frameDataStore.progress_status, (value) => {
      progress_status.value = value
    })

    /**
      * 播放区间 变化时
    */
    watch(() => frameDataStore.currentTimeInterval, (value) => {
      max.value = value.endTs;
      min.value = value.startTs;
      marksTimeLink = frameDataStore.getQueryStartTsMark();
      getPlayInfo(frameDataStore.currentVehicleId, value.startTs, value.endTs)
    })

    watch(() => frameDataStore.currentMissingTimestampList, (missList) => {

    });

    const playItem = computed(() => store.state.wsModule.playItem);


    const formatTooltip = (val: number) => {
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss.SSS');
    };

    const speedFn = (e: any) => {
    };

    const perspectiveFn = (e: any) => {
      store.commit('changePerspective', {
        type: e,
        t: +new Date(),
      });
      store.commit('wsModule/setSelectpoint', false);
    };

    function setMissData(listMap: Map<number, any>, playTime: number, min: any, max: any) {
      let min_m = Math.floor(min / 1000);
      let max_m = Math.ceil(max / 1000);
      let length_total = max_m - min_m; //秒
      let width = 1 / length_total * 100
      let index = playTime - min;
      if (!listMap.has(index)) {
        let left = (playTime - min_m) / length_total * 100
        let width = 1 / length_total * 100
      }
      return {
        left,
        width
      }
    }

    const missingSegments = computed(() => {
      let miss =  getmissingTimeList( min.value, max.value)
      return miss;      
    });
    const catch_time = computed(() => getCatchTimeList(min.value, max.value));
    const catch_time_end = computed(() => {
      let flag_v = Math.max(min.value, (marksTimeLink - 30) * 1000);
      let width_per = frameDataStore.catch_time_end_pre - min.value
      let width_next = frameDataStore.catch_time_end_next - flag_v
      let width_flag = flag_v - min.value

      let length_total = max.value - min.value;
      let width_per_p = Math.min(100, width_per / length_total * 100);
      let width_next_p = Math.min(100, width_next / length_total * 100);
      let flag = Math.min(100, width_flag / length_total * 100);
      ;

      return {
        width_per_p,
        width_next_p,
        flag
      }
    });

    function getmissingTimeList(min: any, max: any) {
      let listMap = new Map();
      let min_m = Math.floor(min / 1000);
      let max_m = Math.ceil(max / 1000);
      let length_total = max_m - min_m; //秒
      let width = 1 / length_total * 100
      frameDataStore.currentMissingTimestampList.forEach((item) => {
        let index = item - min_m;
        if (!listMap.has(index)) {
          let left = index*width;
          listMap.set(index,{
            left,
            width
          })
        }
      })
      return Array.from(listMap.values());
    }

    function getCatchTimeList(min: any, max: any) {
      let listMap = new Map();
      let min_m = Math.floor(min / 1000);
      let max_m = Math.ceil(max / 1000);
      let length_total = max_m - min_m; //秒
      let width = 1 / length_total * 100
      frameDataStore.catch_time_list.forEach((item) => {
        let index = Math.floor(item / 1000) - min_m;
        if (!listMap.has(index)) {
          let left = index*width;
          listMap.set(index,{
            left,
            width
          })
        }
      })
      return Array.from(listMap.values()); 
    }


    /**
     * 播放上一帧、下一帧；
     * @param type 
     */
    const onPrevNextCilck = (type: 'next' | 'prev') => {
      if (type == 'next') {
        frameDataStore.playFrameOne(1);
      } else if (type == 'prev') {
        frameDataStore.playFrameOne(-1);
      }
    };
    //////////////////////
    const onProgressStatusCilck = (status: number) => {
      frameDataStore.setProgress_status(status);
    };

    // 车辆操作记录映射 (强行通过 / 非红即走)
    const modeMap: Record<number, string> = {
      0: '正常识别',
      1: '非红即走',
      2: '强行通过',
    };

    /** 接管类蓝旗（instruction），与 getPlayInfo 触发的 marks 重建分开存，避免被清空后行为不一致 */
    const instructionMarks: Record<number, { label: JSX.Element }> = {};

    const applyInstructionMarks = () => {
      Object.entries(instructionMarks).forEach(([key, mark]) => {
        marks.value[Number(key)] = mark;
      });
    };

    const clearInstructionMarks = () => {
      Object.keys(instructionMarks).forEach((key) => {
        delete instructionMarks[Number(key)];
      });
    };

    /** 从已缓存帧扫描 overwriteMode 跳变，不依赖播放/seek 时的 currentData 顺序 */
    let instructionMarksRebuildTimer = 0;
    const rebuildInstructionMarksFromCache = () => {
      const { startTs, endTs } = frameDataStore.currentTimeInterval;
      if (!startTs || !endTs) return;

      clearInstructionMarks();
      const transitions = scanOverwriteInstructionTransitions(startTs, endTs);
      transitions.forEach(({ timestamp, mode }) => {
        instructionMarks[timestamp] = {
          label: (
            <Mark
              ts={timestamp * 1000000}
              tag='instruction'
              tagname={modeMap[mode]}
            />
          ),
        };
      });
      applyInstructionMarks();
    };

    const scheduleRebuildInstructionMarks = () => {
      if (instructionMarksRebuildTimer) {
        clearTimeout(instructionMarksRebuildTimer);
      }
      instructionMarksRebuildTimer = window.setTimeout(() => {
        instructionMarksRebuildTimer = 0;
        rebuildInstructionMarksFromCache();
      }, 300);
    };

    watch(
      () => [
        frameDataStore.currentTimeInterval.startTs,
        frameDataStore.currentTimeInterval.endTs,
      ],
      () => {
        rebuildInstructionMarksFromCache();
      },
    );

    watch(
      () => frameDataStore.catch_time_list.length,
      () => {
        scheduleRebuildInstructionMarks();
      },
    );


    // offsetSampleVersion：ws 的时钟偏差采样是边下载边到的，采样变化时要重新摆一次旗子
    watch(computed(() => [props.alarmCodeList, props.tags, props.varguardError, props.varguardFatal, props.varguardFristFatal, props.operationLog, store.state.varguardVisible, store.state.checkedEventTags, store.state.checkedAlarmCodeList, offsetSampleVersion.value] as any[]), ([alarmCodeList, tags, varguardError, varguardFatal, varguardFristFatal, operationLog, varguardVisible, checkedEventTags, checkedAlarmCodeList]) => {
      marks.value = {};
      const tempAlarmCode = {};
      alarmCodeList.forEach((item) => {
        if (checkedAlarmCodeList.includes(item.alarmCode)) {
          const key = item.eventTimestamp / 1000000;
          if (!tempAlarmCode[key]) {
            tempAlarmCode[key] = {
              ts: item.eventTimestamp,
              tagList: [item.alarmCodeString],
            };
          } else if (!tempAlarmCode[key].tagList.includes(item.alarmCodeString)) {
            tempAlarmCode[key].tagList.push(item.alarmCodeString);
          }
        }
      })
      for (const [key, { ts, tagList }] of Object.entries(tempAlarmCode)) {
        marks.value[key] = {
          label: <Mark ts={ts} tag="alarmCode" tagList={tagList} />,
        };
      }
      // @ts-ignore
      tags.forEach((item) => {
        if (checkedEventTags?.includes(item.ruleId)) {
          marks.value[item.ts / 1000000] = {
            label: <Mark ts={item.ts} tag='tag' tagname={item.tag} />,
          };
        }
      });
      // @ts-ignore
      if (varguardVisible.includes('varguardError')) {
        varguardError.forEach((item) => {
          marks.value[item.ts / 1000000] = {
            label: <Mark ts={item.ts} tag='varguardError' />,
          };
        });
      }
      // @ts-ignore
      if (varguardVisible.includes('varguardFatal')) {
        varguardFatal.forEach((item) => {
          marks.value[item.ts / 1000000] = {
            label: <Mark ts={item.ts} tag='varguardFatal' />,
          };
        });
      }

      // @ts-ignore
      if (varguardVisible.includes('varguardFristFatal')) {
        varguardFristFatal.forEach((item) => {
          marks.value[item.ts / 1000000] = {
            label: <Mark ts={item.ts} tag='varguardFristFatal' />,
          };
        });
      }
      // 车辆操作日志（一键挪车等）→ 进度条旗子
      // operateTime 形如 '2026-10-13 17:22:05'，属于服务端时钟(serverTime)，
      // 而进度条用的是车端时钟(clientTime)，所以要减掉两个时钟的偏差：
      // 位置 = operateTime - (serverTime - clientTime)
      // Mark 的 ts 需要纳秒，所以再乘 1e6
      const { startTs: intervalStart, endTs: intervalEnd } = frameDataStore.currentTimeInterval;
      operationLog.forEach((item) => {
        const rawMs = dayjs(item.operateTime).valueOf();
        if (!rawMs || Number.isNaN(rawMs)) return;
        const aligned = alignServerTimeToClient(rawMs);
        const ms = aligned.ts;
        // 补偿后超出当前播放区间的旗子不渲染，否则 el-slider 会把它画到轨道外
        if (intervalStart && intervalEnd && (ms < intervalStart || ms > intervalEnd)) return;
        marks.value[ms] = {
          label: (
            <Mark
              ts={ms * 1000000}
              rawTs={rawMs * 1000000}
              offsetMs={aligned.offset}
              serverTime={aligned.sampleServerTime ?? 0}
              clientTime={aligned.sampleClientTime ?? 0}
              offsetSource={aligned.source ?? ''}
              tag='operationLog'
              tagname={item.instructionType}
              operateUser={item.operateUser}
              desc={item.instructionTypeName}
            />
          ),
        };
      });
      //marksTimeLink
      if (marksTimeLink > 0) {
        marks.value[marksTimeLink * 1000] = {
          label: <Mark ts={marksTimeLink * 1000000000} tag='flag' />,
        };
      }
      applyInstructionMarks();
    }
    );
    watch(progressRef, (e) => {
      // @ts-ignore
      e.addEventListener('mousemove', (v) => {
        const { x, width } = e.getBoundingClientRect();
        const value = (v.clientX - x) / width;
        tip.value = {
          left: value * 100,
          content: dayjs((max.value! - min.value!) * value + min.value!).format(
            'YYYY-MM-DD HH:mm:ss',
          ),
        };
      });
      e.addEventListener('mouseout', () => {
        tip.value.left = left;
      });
    });
    function changeHandler() {
    }


    return {
      marks,
      min,
      max,
      value,
      formatTooltip,
      sendProgress,
      tip,
      progressRef,
      playItem,
      store,
      onPrevNextCilck,
      perspectiveFn,
      speedFn,
      perspective: [
        {
          text: '侧视',
          value: PerspectiveEnum.side,
        },
        {
          text: '俯视',
          value: PerspectiveEnum.overlook,
        },
        {
          text: '自由',
          value: PerspectiveEnum.free,
        },
      ],
      speeds: [
        {
          text: '5X',
          value: 5,
        },
        {
          text: '3X',
          value: 3,
        },
        {
          text: '2X',
          value: 2,
        },
        {
          text: '正常',
          value: 1,
        },
        {
          text: '0.5X',
          value: 0.5,
        },
        {
          text: '0.25X',
          value: 0.25,
        },
      ],
      missingSegments,
      catch_time,
      progressValue,
      catch_time_end,
      progress_status,
      onProgressStatusCilck,
      frameDataStore,
      changeHandler
    };
  },
  render() {
    return (
      <div class={styles['progress-wrap']}>
        <div class={styles['play-pause-container']}>
          <ElTooltip content="上一帧">
            <img
              class={styles['play-control-icon']}
              src={prevIcon}
              onClick={() => this.onPrevNextCilck('prev')}
            />
          </ElTooltip>
          {this.progress_status == 1 && (
            <img
              class={styles['play-control-icon']}
              src={playIcon}
              onClick={() => this.onProgressStatusCilck(0)}
            />
          )}
          {this.progress_status == 0 && (
            <img
              class={styles['play-control-icon']}
              src={pauseIcon}
              onClick={() => this.onProgressStatusCilck(1)}
            />
          )}
          <ElTooltip content="下一帧">
            <img
              class={styles['play-control-icon']}
              src={nextIcon}
              onClick={() => this.onPrevNextCilck('next')}
            />
          </ElTooltip>
        </div>
        <div class={styles['el-slider']} ref="progressRef">
          <div class={styles['tip']} style={{ left: `${this.tip.left}%` }}>
            {this.tip.content}
          </div>
          <ElSlider
            step={1000}
            showTooltip
            marks={this.marks.value}
            min={this.min}
            max={this.max}
            v-model={this.frameDataStore.currentTime}
            formatTooltip={this.formatTooltip}
            // @ts-ignore
            onInput={this.sendProgress}
            onChange={this.changeHandler}
            class={styles['el-slider_b']}
          />
          {
            this.missingSegments.map((segment) => (
              <div class={styles['loading-progress_miss']} style={{ left: `${segment.left}%`, width: `${segment.width}%` }}></div>
            ))
          }
          {
            this.catch_time.map((segment) => (
              <div class={styles['loading-progress_cache']} style={{ left: `${segment.left}%`, width: `${segment.width}%` }}></div>
            ))
          }
        </div>
        <div class={styles['radio-item']}>
          视角
          <div class={styles['popover']}>
            <ElRadioGroup
              v-model={this.store.state.perspective.type}
              onChange={this.perspectiveFn}
            >
              {this.perspective.map((item) => {
                return (
                  <ElRadio value={item.value} key={item.value}>
                    {item.text}
                  </ElRadio>
                );
              })}
            </ElRadioGroup>
          </div>
        </div>
        <div class={styles['radio-item']}>
          倍速
          <div class={styles['popover']}>
            <ElRadioGroup
              v-model={this.frameDataStore.play_speet}
              onChange={this.speedFn}
            >
              {this.speeds.map((item) => {
                return (
                  <ElRadio value={item.value} key={item.value}>
                    {item.text}
                  </ElRadio>
                );
              })}
            </ElRadioGroup>
          </div>
        </div>
      </div >
    );
  },
});


export default NewProgress;
